import { render, staticRenderFns } from "./BelowPerformance.vue?vue&type=template&id=0f380b18"
import script from "./BelowPerformance.vue?vue&type=script&lang=js"
export * from "./BelowPerformance.vue?vue&type=script&lang=js"
import style0 from "./BelowPerformance.vue?vue&type=style&index=0&id=0f380b18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports